import React, { useEffect, useState } from 'react';
import Style from './Navbar.module.scss';
import classNames from 'classnames';
import { info } from '../info/Info';
import { SunIcon, MoonIcon, ArrowUpRight } from './ui/Icons';

const links = [
    { name: 'work', to: 'work', index: '01' },
    { name: 'about', to: 'about', index: '02' },
    { name: 'experience', to: 'experience', index: '03' },
    { name: 'contact', to: 'contact', index: '04' },
];

export default function Navbar({ darkMode, handleClick, active, onOpenTerminal }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => {
        document.body.style.overflow = menuOpen ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [menuOpen]);

    return (
        <>
            <nav className={classNames(Style.nav, { [Style.scrolled]: scrolled })}>
                <a href="#top" className={Style.logo} aria-label="back to top">
                    <span className={Style.logoDot} />
                    {info.initials.toLowerCase()}<span className={Style.logoSlash}>/</span>{info.lastName.toLowerCase()}
                </a>

                <ul className={Style.links}>
                    {links.map((link) => (
                        <li key={link.to}>
                            <a
                                href={`#${link.to}`}
                                className={classNames(Style.link, { [Style.active]: active === link.to })}
                            >
                                <span className={Style.index}>{link.index}</span> {link.name}
                            </a>
                        </li>
                    ))}
                </ul>

                <div className={Style.actions}>
                    <button
                        onClick={onOpenTerminal}
                        className={Style.cmdkBtn}
                        aria-label="open portfolio terminal"
                    >
                        <span>⌘K</span> terminal
                    </button>
                    <a
                        href={info.companyUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={Style.companyBtn}
                    >
                        cognivox-ai.com <ArrowUpRight size={12} />
                    </a>
                    <button
                        onClick={handleClick}
                        className={Style.themeBtn}
                        aria-label={darkMode ? 'switch to light mode' : 'switch to dark mode'}
                    >
                        {darkMode ? <SunIcon /> : <MoonIcon />}
                    </button>
                    <button
                        className={classNames(Style.burger, { [Style.open]: menuOpen })}
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label="toggle menu"
                        aria-expanded={menuOpen}
                    >
                        <span /><span />
                    </button>
                </div>
            </nav>

            <div className={classNames(Style.overlay, { [Style.overlayOpen]: menuOpen })}>
                <ul>
                    {links.map((link) => (
                        <li key={link.to}>
                            <a href={`#${link.to}`} onClick={() => setMenuOpen(false)}>
                                <span className={Style.index}>{link.index}</span>
                                {link.name}
                            </a>
                        </li>
                    ))}
                    <li>
                        <a href={info.companyUrl} target="_blank" rel="noopener noreferrer" onClick={() => setMenuOpen(false)}>
                            <span className={Style.index}>↗</span>cognivox-ai.com
                        </a>
                    </li>
                </ul>
            </div>
        </>
    );
}
